// WikiCiteChip.jsx — department-coloured citation chip that deep-links to a page.
import React from 'react';
import { FileText, ArrowUpRight } from 'lucide-react';
import { deptColors } from '../../lib/wikiConstants';

export default function WikiCiteChip({ cite, onOpenDoc }) {
    if (!cite) return null;
    const c = deptColors(cite.dept);
    return (
        <button type="button" onClick={() => onOpenDoc && onOpenDoc(cite.page_id)}
            className={`inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-[11px] font-medium hover:brightness-95 ${c.cite}`}>
            <FileText className="w-3 h-3" />{cite.name || 'Source'}<ArrowUpRight className="w-2.5 h-2.5" />
        </button>
    );
}

export function WikiAiAvatar({ size = 28 }) {
    return (
        <div className="rounded-lg wiki-grad flex items-center justify-center wiki-shadow-ai shrink-0" style={{ width: size, height: size }}>
            <svg width={size * 0.5} height={size * 0.5} viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3Z" />
            </svg>
        </div>
    );
}
